module.exports = __webpack_public_path__ + "img/PCkefu.7a790a2d.png";